import { StyledText } from '@clickcease/cc-client-components-lib'
import React, { ReactNode } from 'react'
import { useTranslation, Trans } from 'react-i18next'

import { WrapperWithButtons } from '../../../../../components/Elements/WrapperWithButtons/WrapperWithButtons'

import {
  ConnectAccountContainer,
  PlatformButtonContainer,
  NewLine,
} from './ConnectionOptions.styled'

export const ConnectionOptions = ({
  onClose,
  children,
  isBusinessAccount,
}: {
  children: ReactNode
  onClose: () => void
  isBusinessAccount?: boolean
}) => {
  const { t } = useTranslation('PMPlatforms')

  const textKey =
    isBusinessAccount && true
      ? 'connection-selection-explainer-business'
      : 'connection-selection-explainer-non-business'

  return (
    <ConnectAccountContainer>
      <WrapperWithButtons
        ghostButtonText={t('cancel-button')}
        onGhostButtonClick={onClose}
        primaryButtonText={t('next-button')}
        onPrimaryButtonClick={() => {}}
        isPrimaryButtonDisabled
      >
        <StyledText variant={'baseLight'}>
          <Trans
            ns="PMPlatforms"
            i18nKey={textKey}
            components={{
              1: <NewLine bigSpace />,
              2: <StyledText variant={'baseBold'}></StyledText>,
              3: <NewLine />,
            }}
          />
        </StyledText>
        <PlatformButtonContainer>{children}</PlatformButtonContainer>
      </WrapperWithButtons>
    </ConnectAccountContainer>
  )
}
